// @ts-strict-ignore
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProjectOptionLocalizationVO, ProjectOptionVO } from '@project/model/vo/project.vo';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '@shared/custom-validators';

@Component({
  standalone: false,
  selector: 'edit-conf-option',
  templateUrl: './edit-conf-option.component.html',
})
export class EditConfOptionComponent implements OnInit {
  @Input() editOption: ProjectOptionVO = null;
  @Input() currentLocale: string;
  @Output() public finish = new EventEmitter<ProjectOptionVO | undefined>();

  public form: FormGroup;

  constructor(private formBuilder: FormBuilder, private bsModalRef: BsModalRef) {
  }

  public ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        optionName: ['', Validators.compose([
          CustomValidators.minMaxLength(2, 255, 'changeProjectOptionDefPopup.error_tooShortError', 'changeProjectOptionDefPopup.error_tooLongError'),
          CustomValidators.trimRequired])]
      }
    );
    this.updateLocalizedOptionName();
  }

  public onCancel(changedOption?: ProjectOptionVO): void {
    this.bsModalRef.hide();
    this.finish.emit(changedOption);
  }

  public onSave(): void {
    if (!this.form.valid) {
      return;
    }
    if (!this.editOption) {
      this.onCancel();
      return;
    }

    const newOptionName: string = this.form.controls.optionName.value;
    let localizationExists: boolean = false;
    for (const optionLocale of this.editOption.localizations) {
      if (optionLocale.locale === this.currentLocale) {
        optionLocale.value = newOptionName;
        localizationExists = true;
        break;
      }
    }
    if (!localizationExists) {
      const localization: ProjectOptionLocalizationVO = new ProjectOptionLocalizationVO();
      localization.locale = this.currentLocale;
      localization.value = newOptionName;
      this.editOption.localizations.push(localization);
    }
    this.onCancel(this.editOption);
  }

  private updateLocalizedOptionName(): void {
    if (!this.editOption || !this.currentLocale) {
      return;
    }

    let optionName: string = '';
    for (const localization of this.editOption.localizations) {
      if (localization.locale === this.currentLocale) {
        optionName = localization.value;
        break;
      }
    }
    this.form.controls.optionName.setValue(optionName);
  }
}
